import React, { Component } from 'react'
import Link from 'gatsby-link'

export default class NextProject extends Component {
  render() {
    const {
      nextProject,
      nextProjectTintColor,
      nextProjectFontColor,
    } = this.props
    const imagePosition = 'center'
    const nextProjectImage = nextProject.footerImage.file.url
    const ArrowSVG = () => (
      <svg
        width="21px"
        height="14px"
        viewBox="0 0 21 14"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Case-Study-Pages" fill="none" fillRule="evenodd">
          <g id="Arrow" stroke={nextProjectFontColor}>
            <polyline
              id="pointer"
              points="13.8654 0.3533 20.4484 6.9363 13.8654 13.5193"
            />
            <path id="line" d="M0.0002,6.9363 L20.4482,6.9363" />
          </g>
        </g>
      </svg>
    )

    return (
      <section id="next-project">
        <div className="grid-row left-margin-only">
          <Link to={`/case-study/${nextProject.slug}`}>
            <div
              className="next-project-module"
              style={{
                backgroundImage: `url(${nextProjectImage})`,
                backgroundPosition: `${imagePosition}`,
              }}
            >
              <div
                className="next-project-text"
                style={{ color: `${nextProjectFontColor}` }}
              >
                <h2>Related Work — </h2>
                <h1>{nextProject.title}</h1>
                <ArrowSVG />
              </div>
              <div
                className="color-overlay"
                style={{ backgroundColor: `${nextProjectTintColor}` }}
              />
            </div>
          </Link>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/case-studies/next-project.js